import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import logoImg from "../Images/logo40.jpg";

const API = process.env.REACT_APP_API_URL || "";

export default function ResetPassword() {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token") || "";

  const [valid, setValid] = useState(null); // null=checking, true=ok, false=invalid
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setValid(false); return; }
    fetch(`${API}/api/reset-password/${token}`)
      .then((r) => r.json())
      .then((d) => setValid(d.ok === true))
      .catch(() => setValid(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError(t("reset.mismatch")); return; }
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/api/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || t("error.generic"));
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="spar-card login-card">
        <div className="login-brand">
          <img src={logoImg} alt="SPAR" className="login-logo" />
          <h1 className="spar-page-title">{t("reset.title")}</h1>
        </div>

        {valid === null && <p style={{ textAlign: "center" }}>{t("loading")}</p>}

        {valid === false && (
          <p className="spar-alert spar-alert-error">{t("reset.expired")}</p>
        )}

        {valid === true && !done && (
          <>
            {error && <div className="spar-alert spar-alert-error">{error}</div>}
            <form onSubmit={handleSubmit} noValidate>
              <div className="spar-form-group">
                <label className="spar-label" htmlFor="reset-pw">
                  {t("reset.newPassword")}
                </label>
                <input
                  id="reset-pw"
                  type="password"
                  className="spar-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8}
                  autoComplete="new-password"
                />
              </div>
              <div className="spar-form-group">
                <label className="spar-label" htmlFor="reset-confirm">
                  {t("reset.confirmPassword")}
                </label>
                <input
                  id="reset-confirm"
                  type="password"
                  className="spar-input"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  autoComplete="new-password"
                />
              </div>
              <button
                type="submit"
                className="spar-btn spar-btn-primary"
                disabled={submitting}
                style={{ width: "100%", justifyContent: "center", height: 48 }}
              >
                {submitting ? (
                  <>
                    <span className="spar-spinner" />
                    {t("reset.submitting")}
                  </>
                ) : (
                  t("reset.submit")
                )}
              </button>
            </form>
          </>
        )}

        {done && (
          <p style={{ textAlign: "center", lineHeight: 1.6 }}>{t("reset.success")}</p>
        )}

        <p style={{ textAlign: "center", marginTop: 16, fontSize: "0.9rem" }}>
          <a href="/login">{t("forgot.backToLogin")}</a>
        </p>
      </div>
    </div>
  );
}
